<section class="home-page">
    <app-translations></app-translations>
</section>
